/**
@ngdoc service
@name mathService

@description
Math Service Supplimental functions to JavaScript's native Math.
*/

(function() {
	var mathService = function() {

		/**
		 * Round a Float
		 * @param Number:Float value - Float to be rounded
		 * @param Number:Integer decimalPlaces - Number of decimal places to round value by
		 * @return Number:Float
		 */
		this.round = function(value, decimalPlaces){
			if(value==null){
				return 0;
			}
			return Number( Math.round( value+'e'+decimalPlaces )+'e-'+decimalPlaces );
		}

		/**
		 * Round a String
		 * @param String value - String to be rounded
		 * @param Number:Integer decimalPlaces - number of decimal places to round value by
		 * @return Number:Float
		 */
	    this.roundFromString = function(value, decimalPlaces){
			if(value==null){
				return 0;
			}
			return this.round( parseFloat(value), decimalPlaces );
		}

		/**
		 * Convert a characteristic and mantissa according to base to produce a "numeral" object
		 * @param Number:Integer characteristic - The whole number or integral part of a logarithm. e.g. 12 of 12.34
		 * @param Number:Integer mantissa - The part of a logarithm after the decimal point. e.g. 34 of 12.34
		 * @param Number:Integer base - Base or radix is the number of different digits or combination of digits and letters that a system of counting uses to represent numbers.
		 * @return Object:{characteristic, mantissa, base}
		 */
		this.numeral = function(characteristic, mantissa, base){
			var numeralParts = {
				characteristic: 0,
				mantissa: 0,
				base: base
			};
			//break everything down into the smallest part
			numeralParts.mantissa 		= characteristic * numeralParts.base + mantissa;
			numeralParts.characteristic = parseInt( numeralParts.mantissa/numeralParts.base );
			numeralParts.mantissa 		= numeralParts.mantissa - numeralParts.characteristic * numeralParts.base;
			return numeralParts;
		}

	}
	mathService.$inject = [];
	angular.module('app').service('mathService', mathService);
}());